import { trans } from "@mongez/localization";
import breadcrumbsBg from "~/assets/images/about-us/breadcrumb.jpg";
import { Breadcrumbs } from "~/design-system/components/breadcrumbs";
import { SubscribeToOurNewsletter } from "~/modules/home/components";
import { URLS } from "~/shared/urls/urls";
import { FlavorListsSlider } from "../components";
import { Flavor } from "../types";

type FlavorListPageProps = {
  data: {
    records: Flavor[];
  };
};

export function FlavorListPage({ data }: FlavorListPageProps) {
  return (
    <section className="min-h-dvh bg-[#F7F7F7]">
      <Breadcrumbs
        title={trans("flavorList")}
        image={breadcrumbsBg}
        items={[
          { text: trans("home"), href: URLS.home },
          { text: trans("flavorList") },
        ]}
      />
      <div className="container h-full py-6 md:py-12">
        <FlavorListsSlider flavorList={data.records} />
      </div>
      <SubscribeToOurNewsletter />
    </section>
  );
}
